document.addEventListener("DOMContentLoaded", (event) => {
  const tabs = document.querySelectorAll(".add-more .tabs-container input");
  if (tabs) {
    tabs[0].checked = true; // Add this line to check the first tab
    tabs.forEach((tab) => {
      if (tab.checked) {
        document.querySelector(
          ".add-more .content" + "-" + tab.dataset.addTab
        ).style.display = "block";
      }
      tab.addEventListener("change", (e) => {
        let contents = document.querySelectorAll(".add-more .tab");
        contents.forEach((content) => {
          content.style.display = "none";
        });
        document.querySelector(
          ".add-more .content" + "-" + tab.dataset.addTab
        ).style.display = "block";
      });
    });
  }
});

const add_more_section = document.querySelector(".add-more");

const options = {
  rootMargin: "100px",
};

const observer = new IntersectionObserver((entry) => {
  if (entry[0].isIntersecting == true) {
    observer.unobserve(add_more_section);

    const add_more_swiper = new window.swiper(".add-more-swiper", {
      slidesPerView: 1.2,
      spaceBetween: 44,
      breakpoints: {
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1028: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
      navigation: {
        nextEl: ".add-more-swiper-button-next",
        prevEl: ".add-more-swiper-button-prev",
      },
    });

    const similar_swiper = new window.swiper(".similar-swiper", {
      slidesPerView: 1.2,
      spaceBetween: 44,
      breakpoints: {
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1028: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
      navigation: {
        nextEl: ".similar-swiper-button-next",
        prevEl: ".similar-swiper-button-prev",
      },
    });
  }
}, options);

observer.observe(add_more_section);
